import { getCustomer } from "../services/customerService";
import { useQuery } from "@tanstack/react-query";

const useCustomer = (id) => useQuery({
    queryKey: ['customer', id],
    queryFn: () => getCustomer(id).then(res => res.data),
    cacheTime: 0
});

export default useCustomer;